/* ADAPTED FROM ZENCHEF-UI */

import { Icon } from '@zenchef/ds-react'
import { IconName } from '@zenchef/icomoon'
import { Flex, FlexProps } from '@zenchef/styled-system/jsx'
import { JsxStyleProps } from '@zenchef/styled-system/types'

interface DoubleCircleIconProps extends FlexProps {
  icon: IconName
  smallIcon?: IconName
  bg?: JsxStyleProps['color']
}

const DoubleCircleIcon = ({ icon, smallIcon, bg, ...props }: DoubleCircleIconProps) => {
  return (
    <Flex {...props} justifyContent='center' alignItems='center'>
      <Flex position='relative' height='84px' width='84px' border='solid 1px rgba(219,217,218,0.6)' borderRadius='50%'>
        <Flex
          position='absolute'
          height='66px'
          width='66px'
          top='50%'
          left='50%'
          m='-33px 0 0 -33px'
          justifyContent='center'
          alignItems='center'
          bg='white'
          borderRadius='50%'
          boxShadow='0 0 4px 0 rgba(0,0,0,0.1)'>
          <Icon name={icon} fontSize='24px' width='24px' height='24px' position='relative'>
            <Icon
              position='absolute'
              name={smallIcon ?? 'check-01'}
              top='50%'
              right='-4px'
              color='white'
              border='2px solid white'
              borderRadius='50%'
              display='flex'
              alignItems='center'
              justifyContent='center'
              height='18px'
              width='18px'
              fontSize='10px'
              bg={bg ?? 'olive.700'}
            />
          </Icon>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default DoubleCircleIcon
